const NEXT_ROUTES = {
  HOME: '/',
  JOB_SEEKER: '/next/job-seeker',
  RECRUITER: '/next/recruiters',
  BLOG: '/next/blog',
  FAQS: '/next/faqs',
  ASSESSMENT_META: '/next/assessment/',
  MOCK_INTERVIEW_META: '/next/mockinterview/',
  JOB_POSTING: '/next/job-posting',
  CREATE_INTERVIEW: '/next/create-interview',
  CREATE_ASSESSMENT: '/next/create-assessment',
  EMPLOYER_EVENTS: '/next/employer-events',
  CANDIDATE_ASSESSMENTS: '/next/candidate-assessments',
  CANDIDATE_EVENTS: '/next/candidate-events',
  MOCK_INTERVIEW_PAGE: '/next/mockinterview-page',
  CANDIDATE_MOCKINTERVIEW: '/next/candidate-mockinterview',
  EMPLOYER_JOB_POSTING: '/next/employer-job-posting',
  EMPLOYER_ASSESSMENT: '/next/employer-assessment',
  EMPLOYER_INTERVIEW: '/next/employer-interview',
  UNIVERSITY_CONNECT: '/next/university-connect',
};

export default NEXT_ROUTES;
